import { useEffect, useState } from 'react';

/**
 * Whole seconds elapsed since `startedAtMs` (server epoch ms), ticking once a second.
 * Falls back to mount time when omitted; clamps skew so a server timestamp never reads negative,
 * and syncs immediately so a refresh mid-work doesn't flash 0:00.
 */
export const useElapsedSeconds = (startedAtMs?: number) => {
  const [elapsed, setElapsed] = useState(() =>
    startedAtMs ? Math.max(0, Math.floor((Date.now() - startedAtMs) / 1000)) : 0,
  );

  useEffect(() => {
    const origin = startedAtMs ?? Date.now();
    const tick = () => setElapsed(Math.max(0, Math.floor((Date.now() - origin) / 1000)));
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, [startedAtMs]);

  return elapsed;
};

/** `elapsed` seconds → "m:ss" (17 → "0:17", 75 → "1:15"). */
export const formatElapsed = (elapsed: number) => {
  const mm = Math.floor(elapsed / 60);
  const ss = String(elapsed % 60).padStart(2, '0');
  return `${mm}:${ss}`;
};
